import { makeStyles } from '@material-ui/core';

const useTextAreaStyles = makeStyles({
  textarea__multiline: {
    height: '200px',
    padding: '5px',
    boxSizing: 'border-box'
  },
  textarea__default: {
    height: '82px',
    padding: '5px',
    boxSizing: 'border-box'
  },
  message__error: {
    color: 'var(--light-venetian-red)',
    fontSize: '13px',
    textAlign: 'right'
  },
  message: {
    color: 'var(--input-optional-label-color)',
    fontSize: '13px',
    textAlign: 'right'
  }
});

export default useTextAreaStyles;